import { InjectionToken } from '@angular/core';

type SentenceCaseTransformations = Record<string, string>;

export type SentenceCaseDictionary = {
    PHRASE_WITH_SPACES: SentenceCaseTransformations;
    WORDS_TO_UPPERCASE: SentenceCaseTransformations;
    MULTIPLE_WORDS_TO_UPPERCASE: SentenceCaseTransformations;
};

export const SENTENCE_CASE_DICTIONARY = new InjectionToken<SentenceCaseDictionary>('__SENTENCE_CASE_DICTIONARY__');
